import Vue from 'vue'
import sticky from 'vue-sticky-directive'

// Pollyfills
import svg4everybody from 'svg4everybody'
import objectFitImages from 'object-fit-images'
import smoothscroll from 'smoothscroll-polyfill'

// SASS
import '../scss/app.scss'

// Random Id
import RandomId from '../components/RandomId'

// Intersection Observer Wrap
import intersection from '../components/intersection'

// Carousel
import GlobalCarousel from '../components/GlobalCarousel'
import GlobalCarouselDot from '../components/GlobalCarouselDot'

// Disclosure
import DisclosureButton from '../components/DisclosureButton'
import DisclosureContent from '../components/DisclosureContent'
import DisclosureContainer from '../components/DisclosureContainer'

// Sundial
import AnimationSundial from '../components/AnimationSundial'

// Player
import PlayerVimeo from '../components/PlayerVimeo'
import PlayerLoader from '../components/PlayerLoader'
import PlayerYoutube from '../components/PlayerYoutube'

// Modal
import ModalButton from '../components/ModalButton'
import ModalContainer from '../components/ModalContainer'

// Accordion
import AccordionContainer from '../components/AccordionContainer'
import AccordionContainerPanel from '../components/AccordionContainerPanel'
import AccordionContainerHeader from '../components/AccordionContainerHeader'
import AccordionContainerHeaderButton from '../components/AccordionContainerHeaderButton'

// Header
import TheHeader from '../components/TheHeader'

// The Timeline
import TheTimeline from '../components/TheTimeline'
import TheTimelineItem from '../components/TheTimelineItem'

// Animation Library
import BaseAnimation from '../components/BaseAnimation'
import BaseAnimationItem from '../components/BaseAnimationItem'
import BaseWindowWidth from '../components/BaseWindowWidth'

// Window Watcher
import BaseWindowWatcher from '../components/BaseWindowWatcher'

const Components = {
  RandomId,
  TheHeader,
  TheTimeline,
  ModalButton,
  PlayerVimeo,
  PlayerLoader,
  intersection,
  BaseAnimation,
  BaseWindowWidth,
  DisclosureButton,
  DisclosureContent,
  DisclosureContainer,
  PlayerYoutube,
  ModalContainer,
  GlobalCarousel,
  TheTimelineItem,
  AnimationSundial,
  BaseAnimationItem,
  BaseWindowWatcher,
  GlobalCarouselDot,
  AccordionContainer,
  AccordionContainerPanel,
  AccordionContainerHeader,
  AccordionContainerHeaderButton,
}

Object.keys(Components).forEach(
  componentName => Vue.component(componentName, Components[componentName]),
)

svg4everybody()
objectFitImages()
smoothscroll.polyfill()

Vue.use(sticky)

Vue.options.delimiters = ['${', '}']

// Pollyfill invocation in mounted
new Vue().$mount('#app')



// WEBPACK FOOTER //
// ./src/js/app.js